import { connect } from 'react-redux'
import { actions } from '../'
import ProductOrderDetail from './ProductOrderDetail'
import { push } from 'connected-react-router'
import queryString from 'query-string'

const mapStateToProps = (
  {
    myOrders: {
      parentOrderDetail,
      orderDetail,
      tracking,
      productDetail,
      orderDetailNotFoundRedux,
      orderDetailNotFound
    },
    router,
    stores: { vouchers },
    pointsPurchase: { config: { packageSize } }
  },
  ownProps
) => {
  const queryStringValues = queryString.parse(router.location.search)
  const trackingAlternative = productDetail && {
    statuses: [
      {
        status: '1',
        name: 'Produto solicitado',
        when: productDetail.insertDate
      },
      {
        status: '2',
        name: 'Produto confirmado no parceiro',
        when: null
      },
      {
        status: '3',
        name: 'Produto enviado para a transportadora',
        when: null
      },
      {
        status: '4',
        name: 'Produto em rota de entrega',
        when: null
      },
      {
        status: '5',
        name: 'Produto entregue',
        when: null
      }
    ]
  }
  return {
    parentOrderDetail,
    orderDetail,
    tracking,
    productDetail,
    previousRoute: queryStringValues.previousRoute,
    orderDetailNotFoundRedux,
    orderDetailNotFound,
    stores: [...vouchers],
    trackingAlternative: trackingAlternative,
    packageSize
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  getVoucherLink: data => {
    return dispatch(actions.getVoucherLink(data))
  },
  getOrderListDetails: fromOrderDetail => {
    return dispatch(
      actions.getOrderListDetails(
        ownProps.match.params.parentOrderId,
        ownProps.match.params.orderId,
        ownProps.match.params.productId,
        fromOrderDetail
      )
    )
  },
  redirect: path => {
    dispatch(push(path))
  },
  getOrderDetailsApi: () => {
    return dispatch(
      actions.getOrderDetailsApi(
        ownProps.match.params.parentOrderId,
        ownProps.match.params.orderId,
        ownProps.match.params.productId
      )
    )
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(ProductOrderDetail)



// WEBPACK FOOTER //
// ./src/Participant/MyOrders/ProductOrderDetail/ProductOrderDetailContainer.js